export const blockIconsHouseholdHouseNew = (
	<span className='material-symbols-outlined'>house</span>
);
